export default __webpack_public_path__ + "static/media/phase1_cover.ff6627d1.jpg";